﻿export default class ApplicationsChangeLog {
	constructor(init) {
		this.modificationTimestamp = null;
		this.questionKey = null;
		this.previousValue = null;
		this.newValue = null;
		this.changeExplanation = null;
		this.metaData = null;

		if (init) {
			this.modificationTimestamp = init.modificationTimestamp;
			this.questionKey = init.questionKey;
			this.previousValue = init.previousValue;
			this.newValue = init.newValue;
			this.changeExplanation = init.changeExplanation;
			this.metaData = init.metaData;
		}
	}
}
